<template>
    <div class="e3-head-icon-round">
        <div class="d-flex align-items-center px-3 py-2">
            <span class="font-weight-bold text-uppercase">{{ $t('Announcements') }}</span>
        </div>
        <div class="d-flex flex-column border-top">
            <template v-if="recentAnnouncements.length">
                <router-link
                    v-for="message in recentAnnouncements"
                    :key="message.id"
                    class="d-block e3-notification-list-item e3-list-item-bg-hover"
                    :to="{ name: 'announcements' }"
                    @click.native="$emit('close', id)">
                    <NotificationListItem :message="message"/>
                </router-link>
            </template>
            <EmptyListMessage v-else wrapper-class="p-2">
                {{ $t('There are no received announcements') }}
            </EmptyListMessage>
        </div>
        <div class="bg-light px-3 py-2 border-top rounded-bottom">
            <router-link :to="{ name: 'announcements' }" @click.native="$emit('close', id)">
                {{ $t('Show all announcements') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import NotificationListItem from './components/NotificationListItem.vue';

export default {
    props: {
        id: [String, Number]
    },

    data() {
        return {
            tab: 'announcements'
        };
    },
    computed: {
        ...mapGetters([
            'recentAnnouncements',
            'unreadAnnouncements',
            'messageTypes'
        ])
    },

    components: {
        NotificationListItem
    },

    created() {
        this.tab = this.messageTypes.announcements;
    },
    destroyed() {
        if(this.unreadAnnouncements) {
            this.$store.dispatch('READ_ANNOUNCEMENTS').then(() => {
                this.$store.dispatch('GET_RECENT_KINDERGARTEN_ANNOUNCEMENTS');
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.e3-notification-list-item {
    color: initial;

    &:hover,
    &:focus {
        text-decoration: none;
    }
}
</style>
